/* **************************************************** Finishing Shedule Appliance */
export interface FSAppliance {
    id: number;
    appliance_name: string;
    created_by: number | null;
}

export const mapFSAppliance = (data: any): FSAppliance => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSAppliance = {
        id: data.id,
        appliance_name: data.appliance_name,
        created_by: data.created_by || null,
    };

    return res;
};

export const mapFSAppliances = (data: any[]): FSAppliance[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSAppliance);
};
